import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './Documentation.css';

const docContent = `
# О проекте «Глаз TON'а»

**Бот «Глаз TON'а»** — универсальный инструмент для поиска и анализа данных в сети TON. Он предназначен для быстрого получения подробной информации по различным запросам.

---

## Что умеет бот?

- **Поиск TON адресов:** Отслеживание и анализ адресов в сети.
- **Поиск по DNS имени:** Выявление информации по доменным именам.
- **Поиск по Telegram ID и username:** Быстрый анализ аккаунтов.
- **Поиск по GetGems username:** Получение данных по специфическим идентификаторам.
- **Поиск по анонимному номеру:** Обнаружение и привязка анонимных номеров.
- **Поиск по Exchange ID:** Анализ активности на биржах.
- **Детальный анализ связей:** Анализ взаимосвязей между кошельками, телефонами и аккаунтами.

---

## Как начать?

Просто отправьте боту один из следующих запросов:

- Telegram username —  *@username*
- Поиск по DNS имени —  *durov.ton*
- Поиск по Telegram ID —  *123456789*
- Поиск по GetGems username —  *@username*
- Поиск по анонимному номеру —  *880770075*
- Поиск по Exchange ID —  *123456*
- Поиск по кошельку —  *UQ...*, *EQ...*, *0:...*

После этого бот мгновенно начнёт поиск и выдаст подробный отчёт.

👉 Начните работу прямо сейчас: [@istoneyebot](https://t.me/istoneyebot)

---

## Новости и обновления

### База данных

- **Биржи:**  
  - Binance — 849 643
  - Bybit — 735 871
  - OKX — 523 794  
  - MEXC — 177 686  
  - Kucoin — 102 583  
  - Gateio — 80 297  
  - Huobi — 21 134

- **Telegram:**  
  - Telegram Stars — 3 397 464  
  - Telegram Premium — 430 244  
  - Telegram Ads — 109 016  
  - Telegram Rewards — 142 442

- **Токены & жетоны:**  
  - С мемпадов — 1 251 012  
  - Остальные — 816 502  
  - Jettons — 110 550

- **Прочее:**  
  - Usernames — 509 736  
  - DNS — 270 808  
  - Tmail — 3 484  
  - Сотрудники — 1 730  
  - Wallet:TGID — 10 007 936

---

## Примеры функционала

> **[03.11.2024 16:08]**  
> **💎 Что умеет бот?**  
> Просто отправьте ему любой из следующих запросов, и он предоставит всю важную информацию:
> - Поиск TON адресов  
> - Поиск по DNS имени  
> - Поиск по Telegram ID  
> - Поиск по Telegram username  
> - Поиск по GetGems username  
> - Поиск по анонимному номеру  
> - Поиск по Exchange ID  
> - Детальный анализ связей между кошельками, телефонами и Telegram аккаунтами
> 
> **⚡️ Мгновенно получите информацию о:**  
> - Балансе кошелька  
> - Состоянии аккаунта  
> - Типе кошелька  
> - Последних транзакциях  
> - Полезных ссылках для просмотра данных на популярных сервисах
> 
> **🚀 Как начать?**  
> Просто отправьте боту нужный запрос — [@istoneyebot](https://t.me/istoneyebot)

---

### Последние обновления:

- **[19.11.2024 0:03]** Бот теперь показывает информацию от [Fragment](https://fragment.com/) – добавлены данные о расходах на рекламу и монетизации через Telegram Stars.
- **[20.11.2024 22:37]** База пополнилась до 2 500 000 telegram:wallet. Теперь бот помечает адреса, использованные для TTB.
- **[23.11.2024 2:26]** Собрана база из 4 000 000 уникальных сочетаний telegram:wallet, добавлены анонимные номера и NFT юзернеймы.
- **[27.11.2024 20:40]** Запущены промокоды в чате @eye_ton_chat – количество использований ограничено (50).
- **[11.12.2024 23:29]** Обновление базы: новые записи по Telegram Stars, Kucoin, Bybit, Binance, OKX, а также данные о сумме, потраченной на покупку Telegram Premium через Fragment.
- **[03.01.2025 1:11]** Полное обновление базы Telegram Stars, отображение затрат в memhash (в TON) и обновление данных о сотрудниках.
- **[03.01.2025 1:38]** Новая функция: получение 20% от доходов бота с каждого приведённого друга и запуск реферальной программы.
- **[04.01.2025 1:14]** Добавлены данные о мемпадах: Blum, PocketFI, Gaspump; обновлено отображение отчёта в PDF.
- **[06.01.2025 23:36]** В отчёте теперь также отображается Tmail, если такая информация найдена.
- **[10.01.2025 19:09]** Введён inline режим для быстрого поиска, показ подарков и обновлений.
- **[11.01.2025 15:39]** Возможность просмотра информации по Telegram даже без подписки.
- **[14.01.2025 4:28]** Отображение созданных токенов пользователем – более 80 000 токенов.
- **[18.01.2025 1:33]** Бот показывает информацию о 800 000 жетонах, найденных у пользователя.
- **[20.01.2025 22:26]** Разбор ситуации с скамом от популярного twitch стримера: подробный анализ транзакций и схемы манипуляций.
- **[27.01.2025 19:41]** Запущен AI-анализ узлов и интерактивная визуализация связей между аккаунтами.
- **[20.03.2025 15:08]** Работа над ботом продолжается: добавлено более 500 тыс. уникальных записей wallet:tgID, улучшена логика работы, отчёт теперь приходит последовательно.

---

## Заключение

Бот "Глаз TON'а" постоянно развивается, обновляется и совершенствуется, чтобы предоставлять максимально подробную и актуальную информацию для своих пользователей. Присоединяйтесь, отправляйте запросы и убедитесь в его возможностях сами!

[Начните работу с ботом → @istoneyebot](https://t.me/istoneyebot)
`;

const Documentation = () => {
    return (
        <section className="documentation" id="documentation">
            <div className="doc-container">
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                    {docContent}
                </ReactMarkdown>
            </div>
        </section>
    );
};

export default Documentation;
